/****************************************************************************
 * COPYRIGHT (c) 2025 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/


import APIManager from "../../ApiManager/ApiManager";
import {
    FETCH_BANNER_DETAILS_REQUEST,
    FETCH_BANNER_DETAILS_SUCCESS,
    FETCH_BANNER_DETAILS_FAILURE,
    FETCH_BANNER_DELETE_REQUEST,
    FETCH_BANNER_DELETE_SUCCESS,
    FETCH_BANNER_DELETE_FAILURE
   } from "./bannerUploadTypes";
import { COMMON_ERROR } from "../ApplicationDetailsError/ApplicationDetailsErrorTypes";

export const fetchBannerDetailsRequest = () => {
    return {
      type: FETCH_BANNER_DETAILS_REQUEST,
    };
  };
  
  export const fetchBannerDetailsSuccess = (bannerData) => {
    return {
      type: FETCH_BANNER_DETAILS_SUCCESS,
      payload: bannerData,
    };
  };
  
  export const fetchBannerDetailsFailure = (error) => {
    return {
      type: FETCH_BANNER_DETAILS_FAILURE,
      payload: error,
    };
  };

  export const fetchDeleteBannerRequest=()=>{
    return{
      type:FETCH_BANNER_DELETE_REQUEST
    }
  }

  export const fetchDeleteBannerSuccess=()=>{
    return{
      type:FETCH_BANNER_DELETE_SUCCESS
    }
  }

  export const fetchDeleteBannerFailed=(error)=>{
    return{
      type:FETCH_BANNER_DELETE_FAILURE,
      payload:error
    }
  }
  
  export const fetchBannerDetails = (applicationId,submissionId,defaultLanguage, image) => {
    return async function (dispatch) {
      dispatch(fetchBannerDetailsRequest());
      try {
        const data = await APIManager.uploadBannerDetails(applicationId, submissionId, defaultLanguage, image);
        dispatch(fetchBannerDetailsSuccess(data));
      } catch (error) {
        dispatch(fetchBannerDetailsFailure(error));
        dispatch(commonError(error, FETCH_BANNER_DETAILS_FAILURE));
      }
    };
  };
  export const fetchDeleteBannerDetails =(applicationId, submissionId,bannerId,defaultLanguage)=>{
      return async function(dispatch){
        dispatch(fetchDeleteBannerRequest())
        try {
          await APIManager.deleteBannerFile(applicationId, submissionId, bannerId,defaultLanguage);
          dispatch(fetchDeleteBannerSuccess());
        } catch (error) {
          dispatch(fetchDeleteBannerFailed(error));
          dispatch(commonError(error, FETCH_BANNER_DELETE_FAILURE));
        }
      }
  }

  export const commonError=(error,errorType)=>{
    return({
      type:COMMON_ERROR,
      payload:{
        message:error.message,
        errorType:errorType
      }
    })
  }